import {
  ContentBlock,
  Heading,
  Stack,
  Strong,
  Columns,
  Column,
  Box,
  Actions,
} from 'braid-design-system';
import React, { type ReactNode } from 'react';

import { ButtonLink } from 'src/components';
import { COMPANY_PROFILES_ENQUIRY } from 'src/shared/links';

import * as styles from './IntroSection.css';

interface Props {
  title: string;
  children: ReactNode;
}

const trackingProps = {
  elementText: 'get started',
  elementDesign: 'button',
  elementAction: 'directs user to company profile enquiry form',
  entryPoint: 'company profiles - create new account',
  actionOrigin: 'top button company profile page',
};

export const IntroSection = ({ title, children }: Props) => (
  <Box paddingTop={['large', 'large', 'none']}>
    <ContentBlock width="large">
      <Box paddingX={['gutter', 'xlarge']}>
        <Columns collapseBelow="desktop" space="gutter" alignY="center">
          <Column width="2/3">
            <Box paddingTop={['none', 'large']}>
              <Box className={styles.introImg} />
            </Box>
          </Column>
          <Column>
            <Box textAlign="left">
              <Stack space="large">
                <Box
                  textAlign={{
                    mobile: 'center',
                    desktop: 'left',
                  }}
                >
                  <Heading level="1">
                    <Strong>{title}</Strong>
                  </Heading>
                </Box>
                <>{children}</>
                <Actions>
                  <ButtonLink
                    tracking="content_element_pressed"
                    href={COMPANY_PROFILES_ENQUIRY}
                    trackingProps={trackingProps}
                    tone="brandAccent"
                  >
                    Get Started
                  </ButtonLink>
                </Actions>
              </Stack>
            </Box>
          </Column>
        </Columns>
      </Box>
    </ContentBlock>
  </Box>
);
